import { PostData } from './model/PostTypes';
import { PortalPostState, TemplateId } from '@lifeserver/shared';

import {
    FeaturedPublicationDTO,
    PublicationDTO,
    PutFeaturedPostsDTO,
    PutScheduleDto,
} from '../hooks/portal';

export interface PortalPublication {
    id: string;
    post: {
        id: string;
        templateId: TemplateId;
        state: PortalPostState;
        payload: PostData;
        notes: string;
        modifiedAt: string;
        postTags?: string[];
        minimumVersion: string | null;
        postLocalizations?: Array<{
            path?: string;
            portalLocalizationId: string;
        }>;
    };
    startTime: Date;
    endTime: Date;
    position: number;
}

export const publicationDtoToPortalPublication = (
    publication: PublicationDTO | FeaturedPublicationDTO,
): PortalPublication => {
    return {
        id: publication.id,
        position: 'position' in publication ? publication.position : 0,
        post: publication.post,
        startTime: new Date(publication.startTime),
        endTime: new Date(publication.endTime),
    };
};

export const portalPublicationToPutPortalPublicationDTO = (
    publication: PortalPublication,
): PutScheduleDto['publications'][number] => {
    return {
        id: publication.id,
        position: publication.position,
        portalPostId: publication.post.id,
        startTime: publication.startTime.toISOString(),
        endTime: publication.endTime.toISOString(),
    };
};

export const portalPublicationToPutFeaturedPostsPublicationDTO = (
    publication: PortalPublication,
): PutFeaturedPostsDTO['featuredPosts'][number] => {
    return {
        id: publication.id,
        portalPostId: publication.post.id,
        startTime: publication.startTime.toISOString(),
        endTime: publication.endTime.toISOString(),
    };
};
